<script lang="ts">
    export let label: string;
    export let onClick: () => void;
    export let type: "primary" | "secondary" = "primary";
    export let disabled: boolean = false;
</script>

<button
    class="custom-btn {type}"
    on:click={onClick}
    disabled={disabled}
>
    {label}
</button>

<style>
    .custom-btn {
        margin-top: 1rem;
        border: none;
        padding: 0.7rem 1.4rem;
        border-radius: 0.5rem;
        font-weight: 600;
        cursor: pointer;
        transition: 0.2s;
    }

    .custom-btn.primary {
        background: var(--primary);
        color: white;
    }

    .custom-btn.primary:hover {
        background: #dc2626;
    }

    .custom-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
